import { useEffect } from 'react';
import { BRAND_INFO } from '../data/mock';

/**
 * Custom hook to set page-specific SEO title
 * If the pageTitle already includes the brand name, it will be used as-is.
 * Otherwise the brand name is appended after a separator.
 */
export const usePageTitle = (pageTitle, description = null) => {
  useEffect(() => {
    const baseTitle = BRAND_INFO.name;
    let finalTitle;
    if (!pageTitle) {
      finalTitle = `${baseTitle} | ${BRAND_INFO.tagline}`;
    } else if (pageTitle.includes(baseTitle)) {
      finalTitle = pageTitle;
    } else {
      finalTitle = `${pageTitle} | ${baseTitle}`;
    }
    document.title = finalTitle;

    if (description) {
      let metaDescription = document.querySelector('meta[name="description"]');
      if (metaDescription) {
        metaDescription.setAttribute('content', description);
      }
    }

    return () => {
      document.title = `${baseTitle} | ${BRAND_INFO.tagline}`;
    };
  }, [pageTitle, description]);
};

export default usePageTitle;
